import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  constructor() {}
  setTokenCookie(cname, cvalue, exdays) {
    var expires;
    if (exdays != 0) {
      let date = new Date();
      date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = 'expires=' + date.toUTCString();

      console.log(expires);
    }
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  deleteTokenCookie(cname, exdays) {
    var expires;
    if (exdays != 0) {
      let date = new Date();
      date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = 'expires=' + date.toUTCString();
    }
    document.cookie = cname + '=' + ';' + expires + ';path=/';
  }
}
